module.exports = __webpack_public_path__ + "img/riekkola_piha.8b5dac31.jpg";